module.exports = __webpack_public_path__ + "media/images/p-about/feature/icon2-a9e4532bebb6e97c83288cdde7476e81.svg";